import { Injectable } from '@angular/core';
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { date } from "@rxweb/reactive-form-validators";

@Injectable({
  providedIn: 'root'
})
export class DatesHandlerService {

  constructor() {
    dayjs.extend(utc);
    dayjs.extend(timezone);
  }

  formatUTCToLocal(date: string, format?: string): string {
    if (date) {
      return dayjs(date).utc().local().format(format || 'MM/DD/YYYY HH:mm');
    }

    return '';
  }

  formatUTCToCST(date: string, format?: string): string {
    if (date) {
      return dayjs(date).tz('CST').format(format || 'MM/DD/YYYY HH:mm');
    }

    return '';
  }

  getNowUTC(): Dayjs {
    return dayjs().utc();
  }
}
